import type { ReactNode } from 'react';

interface Props {
  lines: string[];
  categories: string[];
  selectedLine?: string | undefined;
  selectedCategory?: string | undefined;
  onLineChange: (line: string | undefined) => void;
  onCategoryChange: (category: string | undefined) => void;
  /** Extra controls rendered before the line/category filters (e.g. the
   * admin agent filter). */
  children?: ReactNode;
}

export function FilterBar({
  lines, categories, selectedLine, selectedCategory, onLineChange, onCategoryChange, children,
}: Props) {
  return (
    <div className="filter-bar" role="group" aria-label="Filtros">
      {children}
      <FilterDropdown
        label="Línea"
        value={selectedLine}
        options={lines}
        onChange={onLineChange}
        emptyLabel="Todas las líneas"
      />
      <FilterDropdown
        label="Categoría"
        value={selectedCategory}
        options={categories}
        onChange={onCategoryChange}
        emptyLabel="Todas las categorías"
      />
      {(selectedLine || selectedCategory) && (
        <button
          type="button"
          className="filter-clear"
          onClick={() => { onLineChange(undefined); onCategoryChange(undefined); }}
          aria-label="Limpiar filtros"
        >
          Limpiar
        </button>
      )}
    </div>
  );
}

interface DropdownProps {
  label: string;
  value: string | undefined;
  options: string[];
  emptyLabel: string;
  onChange: (v: string | undefined) => void;
}

function FilterDropdown({ label, value, options, emptyLabel, onChange }: DropdownProps) {
  return (
    <label className="filter-dropdown">
      <span>{label}</span>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value === '' ? undefined : e.target.value)}
      >
        <option value="">{emptyLabel}</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  );
}
